export const MINIMUM_OUTSIDE_AIR_DAMPERS_SETPOINT = 0;
export const MAXIMUM_OUTSIDE_AIR_DAMPERS_SETPOINT = 100;

export const MINIMUM_ANTI_FREEZE_ALARM_SETPOINT = 2;
export const MAXIMUM_ANTI_FREEZE_ALARM_SETPOINT = 15;

export const DEFAULT_SUMMER_OCC_TEMPERATURE_SETPOINT = 26;
export const MINIMUM_SUMMER_OCC_TEMPERATURE_SETPOINT = 0;
export const MAXIMUM_SUMMER_OCC_TEMPERATURE_SETPOINT = 40;

export const DEFAULT_SUMMER_INOCC_TEMPERATURE_SETPOINT = 35;
export const MINIMUM_SUMMER_INOCC_TEMPERATURE_SETPOINT = 0;
export const MAXIMUM_SUMMER_INOCC_TEMPERATURE_SETPOINT = 40;

export const DEFAULT_WINTER_OCC_TEMPERATURE_SETPOINT = 19;
export const MINIMUM_WINTER_OCC_TEMPERATURE_SETPOINT = 0;
export const MAXIMUM_WINTER_OCC_TEMPERATURE_SETPOINT = 40;

export const DEFAULT_WINTER_INOCC_TEMPERATURE_SETPOINT = 17;
export const MINIMUM_WINTER_INOCC_TEMPERATURE_SETPOINT = 0;
export const MAXIMUM_WINTER_INOCC_TEMPERATURE_SETPOINT = 40;

export const MINIMUM_SUPPLY_AIR_MIN_TEMPERATURE_SETPOINT = 0;
export const MAXIMUM_SUPPLY_AIR_MIN_TEMPERATURE_SETPOINT = 40;

export const MINIMUM_SUPPLY_AIR_MAX_TEMPERATURE_SETPOINT = 0;
export const MAXIMUM_SUPPLY_AIR_MAX_TEMPERATURE_SETPOINT = 40;

export const DEFAULT_SUMMER_OCC_FLOW_SETPOINT = 7000;
export const DEFAULT_SUMMER_INOCC_FLOW_SETPOINT = 6000;
export const DEFAULT_WINTER_OCC_FLOW_SETPOINT = 6000;
export const DEFAULT_WINTER_INOCC_FLOW_SETPOINT = 5000;

export const MINIMUM_DEAD_BAND = 1;
export const MAXIMUM_DEAD_BAND = 10;
export const DEAD_BAND_STEP = 1;

export const MINIMUM_PRESSURE_SETPOINT = 0;
export const MAXIMUM_PRESSURE_SETPOINT = 2000;
export const PRESSURE_STEP = 10;

// Fallback when the automate does not report its flow bounds, which is the case across the whole
// fleet until `DEBIT_<D>_CSG_MIN` / `_MAX` are programmed. 100 m³/h is the historical range: a zero
// flow is only reachable when the automate itself bounds it at 0.
export const MINIMUM_FLOW_SETPOINT = 100;
export const MAXIMUM_FLOW_SETPOINT = 15000;

export const MINIMUM_HUMIDITY_SETPOINT = 0;
export const MAXIMUM_HUMIDITY_SETPOINT = 100;
export const HUMIDITY_STEP = 1;

// Operating range of an AHU CO2 probe. The floor is the outdoor air level: a setpoint below it is
// unreachable and would keep the fans at full speed. The ceiling covers the three EN 16798-1
// categories, whose usual setpoints run from 950 to 1750 ppm.
export const MINIMUM_CO2_SETPOINT = 400;
export const MAXIMUM_CO2_SETPOINT = 2000;
export const CO2_STEP = 10;

export const DEFAULT_FREE_COOLING_DELTA = 4;
export const MINIMUM_FREE_COOLING_DELTA = 1;
export const MAXIMUM_FREE_COOLING_DELTA = 15;

export const STEP = 0.5;
